import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex gap-5',
    card: 'flex-1',
    carousel:
      '[--slide-size:auto] [--slide-spacing:12px] max-md:-mx-3 md:[--slide-size:calc(100%/2)] lg:[--slide-spacing:24px]',
    viewport: 'max-md:px-3'
  }
});
